import type { createSavedComponentsApi } from './savedComponentsWrapper';
import type { PublicApiKey } from '@/apilib';

export const SavedComponentsApiKey: PublicApiKey<
  typeof createSavedComponentsApi
> = {
  name: 'SavedComponentsApi',
  public: true,
};
